/**
 * Massy Boutique — Scroll-triggered animations & card effects
 *
 * Usa IntersectionObserver per aggiungere la classe `mb-animated`
 * agli elementi con `mb-will-animate` / `mb-will-animate-title`
 * quando entrano nel viewport, producendo un fade-up fluido.
 */

(function () {
  'use strict';

  /** Selettori da osservare */
  const CARD_SELECTOR = '.resource-list__item';
  const TITLE_SELECTOR = '.section-resource-list__header';
  const HERO_SELECTOR = '[data-template="index"] .hero-wrapper:first-of-type';

  /** Soglia di visibilità (0–1) */
  const THRESHOLD = 0.12;

  /**
   * Aggiunge la classe di animazione a tutti gli elementi che
   * corrispondono a `selector` all'interno di `root`.
   * @param {string} baseClass  classe-base per il marker
   * @param {string} animClass  classe di animazione finale
   */
  function observeElements(baseClass, animClass) {
    const elements = document.querySelectorAll('.' + baseClass);
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(animClass);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
  }

  /**
   * Inietta le classi di preparazione sugli elementi target.
   * Eseguita dopo che il DOM è pronto, ma prima che le section vengano mostrate.
   */
  function prepareElements() {
    // Titoli di sezione
    document.querySelectorAll(TITLE_SELECTOR).forEach((el) => {
      if (!el.classList.contains('mb-will-animate-title')) {
        el.classList.add('mb-will-animate-title');
      }
    });

    // Card prodotto / collezione / articolo
    document.querySelectorAll(CARD_SELECTOR).forEach((el) => {
      if (!el.classList.contains('mb-will-animate')) {
        el.classList.add('mb-will-animate');
      }
    });
  }

  /** Inizializzazione */
  function init() {
    // Rispetta la preferenza di riduzione del moto
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Mostra subito tutto senza animazione
      document.querySelectorAll('.mb-will-animate, .mb-will-animate-title').forEach((el) => {
        el.classList.add('mb-animated');
      });
      return;
    }

    prepareElements();
    observeElements('mb-will-animate', 'mb-animated');
    observeElements('mb-will-animate-title', 'mb-animated');
  }

  // Esegui quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ri-osserva dopo un Shopify section-render (tema editor / sezioni dinamiche)
  document.addEventListener('shopify:section:load', () => {
    prepareElements();
    observeElements('mb-will-animate', 'mb-animated');
    observeElements('mb-will-animate-title', 'mb-animated');
  });
})();
